// Quem emitiu o passe de troca de plano (`iss` do JWT) — 2026-10-20.
//
// SÓ pra escolher o VISUAL da /checkout/trocar. Não valida assinatura nem
// prazo: quem decide se o passe vale é o servidor (handoff-token.service), em
// toda chamada. Ler o `iss` aqui tira a dependência do `saas=reservei` que o
// app do Reservei acrescenta ao link — versão antiga em cache ou um botão novo
// sem o parâmetro jogaria o cliente no visual padrão.

export function readHandoffIssuer(token: string | null | undefined): string | null {
  if (!token) return null;
  const [, payload] = token.split('.');
  if (!payload) return null;
  try {
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const padded = base64 + '='.repeat((4 - (base64.length % 4)) % 4);
    const claims: unknown = JSON.parse(atob(padded));
    if (claims && typeof claims === 'object' && 'iss' in claims) {
      const iss = (claims as { iss: unknown }).iss;
      return typeof iss === 'string' ? iss : null;
    }
    return null;
  } catch {
    return null;
  }
}
